import React, {useState} from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';

const BurgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);

    const closeMenu = () => {
        setIsOpen(false); // Update the state to close the menu
    };

    const handleStateChange = (state) => {
        setIsOpen(state.isOpen); // Sync state with the menu's state
    };

    return (
        <div className="burger-menu">
            <Menu
                className="burger-container"
                width={280}
                isOpen={isOpen}
                onStateChange={handleStateChange} // Sync with the burger menu's state
                onClose={closeMenu} // Optional: Close when menu loses focus
            >
                <NavLink to="/home" className="burger-container__item" onClick={closeMenu}>
                    Home
                </NavLink>
                <NavLink to="/services" className="burger-container__item" onClick={closeMenu}>
                    Services
                </NavLink>
                <NavLink to="/about" className="burger-container__item" onClick={closeMenu}>
                    About
                </NavLink>
                <NavLink to="/contact" className="burger-container__item" onClick={closeMenu}>
                    Contact
                </NavLink>
            </Menu>
        </div>
    );
};

export default BurgerMenu;
